import ArrowDownIcon from '@ps-design-system/icons/ArrowDown/ArrowDown20';
import React from 'react';

export const CateringHeroMenuLink = ({ title, href }) => {
  const scrollToSection = (e) => {
    e.preventDefault();
    const section = document.getElementById(href.replace('#', ''));
    const sectionTop = section.getBoundingClientRect().top + window.scrollY;
    const navbarHeight = 72;
    const bookingDetailsBarHeight = 74;
    let offset = navbarHeight;
    if (window.innerWidth >= 992) {
      offset = navbarHeight + bookingDetailsBarHeight;
    }
    window.scrollTo({ top: sectionTop - offset, behavior: 'smooth' });
  };

  return (
    <li className="flex middle">
      <ArrowDownIcon
        height={20}
        width={20}
        className="text-gray-darker margin-md-right"
      />
      <a
        className="tw-headline-2-m-underline no-margin"
        href={href}
        onClick={scrollToSection}
      >
        {title}
      </a>
    </li>
  );
};
